export default __webpack_public_path__ + "static/media/OtherIcon.75f88e11.svg";